var map = {
	"./BrandLotteries-navbar": "app/views/pages/queries/navbar/BrandLotteries-navbar",
	"./Brands-navbar": "app/views/pages/queries/navbar/Brands-navbar",
	"./Lotteries-navbar": "app/views/pages/queries/navbar/Lotteries-navbar",
	"./Players-navbar": "app/views/pages/queries/navbar/Players-navbar",
	"./TicketLineDraws-navbar": "app/views/pages/queries/navbar/TicketLineDraws-navbar",
	"./TicketLines-navbar": "app/views/pages/queries/navbar/TicketLines-navbar",
	"./Transactions-navbar": "app/views/pages/queries/navbar/Transactions-navbar",
	"./eventlogs-navbar": "app/views/pages/queries/navbar/eventlogs-navbar"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./ClientApp/app/views/pages/queries/navbar sync recursive ^\\.\\/.*\\-navbar$";